import { useNitroPool } from '@app/hooks/nitro/useNitroPool';
import { useContract } from '@thirdweb-dev/react-core';
import NitroPoolAbi from '../../../abis/NitroPool.json';
import { useQuery } from '@tanstack/react-query';
import { QueryKeys } from '@app/constants/queryKeys';
import { SmartContract, useAddress } from '@thirdweb-dev/react';
import { ethers } from 'ethers';
import { Address } from '@thirdweb-dev/sdk';
import { useMemo } from 'react';

async function fetcher(
  contract: SmartContract<ethers.BaseContract> | undefined,
  tokenId: string,
  address: Address | undefined
) {
  if (!contract) {
    return null;
  }

  const tokenIdsLength = await contract.call('userTokenIdsLength', [address]);

  const ids: number[] = await Promise.all(
    new Array(tokenIdsLength).fill(0).map(async (_, i) => {
      return await contract.call('userTokenId', [address, i]);
    })
  );

  return ids;
}

export function useIsStakedToNitro(nftPullAddress: string, nftTokenId: string) {
  const { data: nitroPool } = useNitroPool(nftPullAddress);
  const address = useAddress();

  const { contract: nitroPoolContract } = useContract(
    nitroPool?.id,
    NitroPoolAbi.abi
  );

  const { data: userTokenIds } = useQuery(
    [
      QueryKeys.NITRO_POOL_USER_TOKEN_ID,
      nftTokenId,
      address,
      !!nitroPoolContract
    ],
    () => fetcher(nitroPoolContract, nftTokenId, address),
    {
      enabled: !!nitroPool
    }
  );

  return useMemo(() => {
    return userTokenIds?.some(userTokenId => {
      return +userTokenId.toString() === +nftTokenId;
    });
  }, [nftTokenId, userTokenIds]);

  // find nitro by NFT pool address
  // get userTokenIdsLength
  // get userTokenId => tokenId
  // if tokenId === kpNFT token Id => return true
}
